import React, { lazy, useMemo } from 'react';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';

const Report = lazy(() => import('./ReportPage/WorkflowReportPage'));

function ReportDesignSelector() {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();

    const isClassic = useMemo(
        () => window.localStorage.getItem('report-classic-design') === 'true',
        [location.pathname],
    );

    if (isClassic) {
        const workflowType = params.workflowType;
        const reportId = params.reportId;
        const search = location.search || '';
        const url = `/report/classic/${workflowType}/${reportId}${search}`;
        navigate(url);
        window.location.hash = url;
        return null;
    }

    return <Report key={Date.now()} />;
}

export function ReportsRoutes() {
    return (
        <Routes>
            <Route path="/report/:workflowType/:reportId" element={<ReportDesignSelector />} />
            <Route path="/report/modern/:workflowType/:reportId" element={<Report key={Date.now()} />} />
            <Route path="/report/show" element={<Report key={Date.now()} />} />

            <Route path="*" element={null} />
        </Routes>
    );
}
